import { truncateTextWithEllipsis } from '@utilities';

/**
 * gets option label based on prompt description
 * @param {Object} params - The parameters object.
 * @param {number} params.childLength - The maximum length for truncating the child text (optional).
 * @param {number} params.length - The maximum length for truncating the parent text (optional).
 * @param {Object} params.option - The option object to generate the label for.
 * @return {String|Node}
 */
export const getOptionLabel = ({ childLength, length, option }) => {
  if (!option) return '';

  const [rawParent, rawChild] = option?.prompt_desc?.split(' || ') || [];

  const parent = rawParent?.trim();
  const childRaw = rawChild?.replace(`(${parent})`, '').trim();

  const parentLabel = length ? truncateTextWithEllipsis({ length, text: parent }) : parent;

  const childLabel = childLength
    ? truncateTextWithEllipsis({ length: childLength, text: childRaw })
    : childRaw;

  if (childLabel) {
    return (
      <>
        {childLabel}
        <span>&nbsp;- {parentLabel}</span>
      </>
    );
  }

  if (option?.operatorInfo) return option?.metric?.name;

  return option?.name || '';
};
